// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"a5f84fc1","493":"ebccf9f0","981":"04c67eca"}[chunkId] + ".css";
};